import React, { useEffect, useMemo, useState } from "react"
import { createContext, ReactNode, useContext } from "react"
import { Disposition } from "../../Models/disposition"
import { SessionState } from "../../Models/sessionState"
import { UserInfo } from "../../Models/userInfo"
import { BaseRetorikConfig, RetorikConfiguration } from "../Bot/data"

type Props = {
    children: ReactNode
}

type AjadiContextType = {
    userInfo : UserInfo | undefined
    retorikConfig : RetorikConfiguration
    showBot : boolean
    sessionState : SessionState
    testMode : boolean
    disposition : Disposition,
    defaultMode : number
    setUserInfo : (x : UserInfo | undefined) => void
    setRetorikConfig: (x: RetorikConfiguration) => void
    setShowBot : (x : boolean) => void
    setTestMode : (x : boolean) => void
    setSessionState: (x : SessionState) => void
    setDisposition: (x: Disposition) => void
    setDefaultMode: (x:number) => void
}

const AjadiContextDefaultValues: AjadiContextType = {
    userInfo : undefined,
    retorikConfig : BaseRetorikConfig,
    showBot : false,
    testMode : false,
    sessionState : SessionState.NoSession,
    disposition:Disposition.Base,
    defaultMode : 1,
    setUserInfo: () => {},
    setRetorikConfig: () => {},
    setShowBot: () => {},
    setTestMode : () => {},
    setSessionState: () => {},
    setDisposition: () => {},
    setDefaultMode: () => {},
}

export const AjadiContext = createContext<AjadiContextType>( AjadiContextDefaultValues );

export function useAjadi() {
    return useContext(AjadiContext)
}

export function AjadiProvider({ children }: Props) {
    const [userInfo, setUserInfo] = useState<UserInfo | undefined>(undefined)
    const [retorikConfig, setRetorikConfig] = useState<RetorikConfiguration>(AjadiContextDefaultValues.retorikConfig)
    const [disposition, setDisposition] = useState<Disposition>(Disposition.Base)
    const [defaultMode, setDefaultMode] = useState<number>(1)
    const [showBot, setShowBot] = useState<boolean>(false)
    const [testMode, setTestMode] = useState<boolean>(false)
    const [sessionState, setSessionState] = useState<SessionState>(SessionState.NoSession)

    const value = useMemo(()=> ({
            userInfo: userInfo,
            retorikConfig : retorikConfig,
            sessionState : sessionState,
            showBot:showBot,
            testMode:testMode,
            disposition:disposition,
            defaultMode:defaultMode,
            setRetorikConfig,
            setUserInfo,
            setShowBot,
            setTestMode,
            setSessionState,
            setDisposition,
            setDefaultMode
        }),[
            userInfo,
            retorikConfig,
            sessionState,
            showBot,
            testMode,
            disposition,
            defaultMode,
            setRetorikConfig,
            setUserInfo,
            setShowBot,
            setTestMode,
            setSessionState,
            setDisposition,
            setDefaultMode
        ]);
    
        useEffect(()=>{
            console.log("retorikConfig", retorikConfig);
        }, [retorikConfig])
  
    return (
        <React.Fragment>
            <AjadiContext.Provider value={value}>
                {children}
            </AjadiContext.Provider>
        </React.Fragment>
        )
    }